import TemplateView from '../../../TemplateView'
import SortButton from './SortButton'

export default class ConfigPanel extends TemplateView
{
    templateHtml()
    {
        return "<div class='configPanel'>" +
               "  <span class='viewByLabel'><%=viewByLabel%></span>" +
               "  <div class='viewByDaysContainer'></div>" +
               "  <span class='separator'></span>" +
               "  <div class='viewByCPContainer'></div>" +
               "  <div class='showTasksContainer'>" +
               "    <label><input type='checkbox' class='showTasks'/><%-showTasksLabel%></label>" +
               "  </div>" +
               "</div>"
    }

    afterRender()
    {
        this.configModel = ViewTTStore.getDetailsTableConfig();

        this.viewByDaysButton = new SortButton({
                active: this.configModel.viewByDays,
                asc: this.configModel.asc,
                titleLabel: "view_tt.details_table.view_by_days",
                onClick: this.bind(this._onViewByDaysButtonClick)
        }).init(this.find(".viewByDaysContainer"));

        this.viewByCPButton = new SortButton({
                active: !this.configModel.viewByDays,
                asc: this.configModel.asc,
                titleLabel: "view_tt.details_table.view_by_cp",
                onClick: this.bind(this._onViewByCPButtonClick)}
                ).init(this.find(".viewByCPContainer"));

        this.$showTasksCheckbox = this.findAndBindClick(".showTasks", this._onShowTasksCheckboxClick);
        if (this.configModel.showTasks)
            this.$showTasksCheckbox.attr("checked", true);
        else
            this.$showTasksCheckbox.removeAttr("checked");
    }

    messageKeys()
    {
        return {
            viewByLabel: "view_tt.details_table.view_by",
            showTasksLabel: "view_tt.details_table.show_tasks"
        }
    }

    _onViewByDaysButtonClick()
    {
        this.configModel.viewByDays = true;
        this.configModel.asc = this.viewByDaysButton.isAsc();
        this.viewByCPButton.setActive(false);
        this._triggerChange();
    }

    _onViewByCPButtonClick()
    {
        this.configModel.viewByDays = false;
        this.configModel.asc = this.viewByCPButton.isAsc();
        this.viewByDaysButton.setActive(false);
        this._triggerChange();
    }

    _onShowTasksCheckboxClick()
    {
        this.configModel.showTasks = !!this.$showTasksCheckbox.attr("checked");
        this._triggerChange();
    }

    _triggerChange()
    {
        $(document).trigger("viewTT.detailsTable.configPanel.change", this.configModel);
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ConfigPanel.js